import { PChatSDK } from '@sscale/pchatsdk';

const PChat = new PChatSDK();
PChat._cache = {};

PChat.on(PChat.Events.REACTIONS_STATS, (stats) => {
  PChat._cache['reaction_stats'] = stats;
});

PChat.on(PChat.Events.CONNECT, async () => {
  try {
    await PChat.getReactionStats();
    await PChat.loadOlder();
  } catch (e) {
    console.log(e);
  }
});

PChat.init = async (room, userId, eveKey, token) => {
  if (PChat.state !== PChat.States.CONNECTED) {
    let authToken = process.env.REACT_APP_CHAT_TOKEN || token;
    if (!authToken) {
      return;
    }

    await PChat.connect(room, userId, authToken, { role: 'moderator' });
  }
};

export default PChat;
